module.exports = __webpack_public_path__ + "img/twitter.47897491.svg";